import { Box, Button, IconButton, Typography } from '@mui/material'

import FormRow from 'components/form/FormRow'
import React from 'react'
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { NestedField, useFieldValue } from 'components/form/input/NestedField';
import TextInput from 'components/form/input/TextInput';
import SelectInput from 'components/form/input/SelectInput';

function CardQuestao({
    index,
    deleteIntervalo
}) {

    return (


        <FormRow
            sx={{
                justifyContent: "center",
                mb: 1,
                backgroundColor: "rgba(125,125,125,0.2)",
                p: 1,
                display: "flex",
            }}
        >
            <TextInput
                name="key"
                label="Chave de Identificação"
                multiline
                required

            />

            <TextInput
                name="questao"
                label="Texto da Questão"
                multiline
                required
            />
            <SelectInput
                name="type"
                label="Tipo"
                options={["text", "textMult", "number", "date", "instrucao"]}
                optionsToString={["Texto", "Texto multilinhas", "Numérico", "Data", "Exibir apenas a instrução"]}
                required
            />
            <SelectInput
                name="required"
                label="Obrigatório"
                options={["SIM", "NÃO"]}
                required
            />
            <IconButton aria-label="delete" onClick={deleteIntervalo}>
                <DeleteIcon />
            </IconButton>
        </FormRow>

    );
}


export default function QuestoesSecundaria() {
    const [questoes, setQuestoes] = useFieldValue('questoesSecundarias');

    console.log('questoes', questoes)
    const addItem = () => {
        let array = [...questoes];
        array.push({ type: "text", required: "NÃO" })

        setQuestoes(array);
    };

    const deleteItem = (index) => {
        let array = [...questoes];
        array.splice(index, 1);

        setQuestoes(array);
    };

    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column" }}>
            <FormRow
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "nowrap",
                }}
            >
                <Typography variant="h6">{'Questionário Secundário'}</Typography>
                <Box sx={{ display: "flex" }}>

                    <Button onClick={addItem} sx={{ m: 1, alignSelf: "flex-end" }} startIcon={<AddIcon />}>
                        Novo
                    </Button>
                </Box>
            </FormRow>
            {questoes.length !== 0 ? (
                questoes.map((intervalo, index) => (
                    <NestedField key={index} prefix={'questoesSecundarias'} index={index}>

                        <CardQuestao
                            key={index}
                            index={index}
                            deleteIntervalo={() => deleteItem(index)}
                        />
                    </NestedField>
                ))
            ) : (
                <FormRow sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ color: "text.disabled" }}>- NENHUMA QUESTÃO ADICIONADA -</Typography>
                </FormRow>
            )}
            <Typography variant='caption'>
                A 'Chave de Identificação é um nome único que identifica a questão.(Ex: questao: 'Informe o nome completo da mãe', chave:'nomeMae'
            </Typography>
        </Box>
    )
}
